import React from 'react';
import { Row, Col } from 'reactstrap';
import { Link } from 'react-router-dom';
import { Compass, BookOpen, History, Sparkles, ArrowUpRight } from 'lucide-react';

const quickLinks = [
  {
    title: 'Contextual Theology',
    subtitle: 'Inclusive & Liberative',
    icon: <Compass size={22} />,
    link: '/about/vision-mission',
    color: '#1a2b56'
  },
  {
    title: 'Vision & Mission',
    subtitle: 'Faith Seeking Justice',
    icon: <Sparkles size={22} />,
    link: '/about/vision-mission',
    color: '#79031d'
  },
  {
    title: 'Our History',
    subtitle: '150+ Years Legacy',
    icon: <History size={22} />,
    link: '/about/history',
    color: '#1a2b56'
  },
  {
    title: 'Formation',
    subtitle: 'Transformative Growth',
    icon: <BookOpen size={22} />,
    link: '/about/formation',
    color: '#79031d'
  }
];

export default function NewFaceView() {
  return (
    <div className="vj-quick-features pt-3">
      <Row className="g-3">
        {quickLinks.map((item, idx) => (
          <Col xl={3} lg={6} md={6} sm={6} xs={12} key={idx}>
            <Link to={item.link} className="text-decoration-none">
              <div 
                className="vj-quick-card p-3 rounded-4 bg-white d-flex align-items-center justify-content-between h-100"
                style={{
                  border: '1px solid rgba(15, 28, 63, 0.08)',
                  boxShadow: '0 4px 14px rgba(15, 28, 63, 0.04)',
                  transition: 'all 0.25s ease'
                }}
              >
                <div className="d-flex align-items-center gap-3">
                  <div 
                    className="flex-shrink-0 d-flex align-items-center justify-content-center rounded-3 text-white"
                    style={{
                      width: '44px',
                      height: '44px',
                      backgroundColor: item.color,
                      boxShadow: `0 4px 10px ${item.color}33`
                    }}
                  >
                    {item.icon}
                  </div>
                  <div>
                    <h6 className="fw-bold mb-0 text-dark" style={{ fontSize: '0.92rem' }}>
                      {item.title}
                    </h6>
                    <span className="text-muted" style={{ fontSize: '0.78rem' }}>
                      {item.subtitle}
                    </span>
                  </div>
                </div>
                <ArrowUpRight size={16} className="text-muted opacity-60 flex-shrink-0" />
              </div>
            </Link>
          </Col>
        ))}
      </Row>
    </div>
  );
}
